import React from 'react';

import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';

import { PRIMARY_PURPLE } from '../../theme/colorConstants';

const PurpleSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme: muiTheme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: PRIMARY_PURPLE[50],
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: PRIMARY_PURPLE[70],
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color:
        muiTheme.palette.mode === 'light' ? muiTheme.palette.grey[100] : muiTheme.palette.grey[600],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: muiTheme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: muiTheme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
    opacity: 1,
    transition: muiTheme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

export default PurpleSwitch;
